/**
 * Front End JS file.
 */

"use strict";
var wkmp = jQuery.noConflict();

var wkJQ = jQuery.noConflict();
document.addEventListener("DOMContentLoaded", function () {
	if (wkmp('.wkmp-select2').length) {
		wkmp('.wkmp-select2').select2();
	}
	if (wkmp("#mp_seller_product_categories").length) {
		wkmp("#mp_seller_product_categories").select2();
		wkmp('.wc-product-search').select2();
	}

	if (wkmp('#new_zone_locations').length) {
		wkmp('#new_zone_locations').select2()
	}
});

wkmp(window).on('load', function () {
	wkmp('.add-product-form .select2-container').css('width', '100%');
	wkmp('.wkmp_nav_tabs a').css('text-decoration', 'none');
	wkmp('.woocommerce-pagination a').css('text-decoration', 'none');

	wkmp(document).on('click', '#wk_stock_management', function () {
		if (wkmp(this).is(':checked')) {
			wkmp('.wkmp_profile_input #wk-mp-stock-qty').parent('.wkmp_profile_input').css('display', 'block');
			wkmp('.wkmp_profile_input #_backorders').parent('.wkmp_profile_input').css('display', 'block');
			wkmp('.wkmp_profile_input #wk-mp-stock-threshold').parent('.wkmp_profile_input').css('display', 'block');
		} else {
			wkmp('.wkmp_profile_input #wk-mp-stock-qty').parent('.wkmp_profile_input').css('display', 'none');
			wkmp('.wkmp_profile_input #_backorders').parent('.wkmp_profile_input').css('display', 'none');
			wkmp('.wkmp_profile_input #wk-mp-stock-threshold').parent('.wkmp_profile_input').css('display', 'none');
		}
	});

	// Seller review box.
    wkmp('.mp-avg-rating-box-link').on('click', function (event) {
        event.stopPropagation();
		if (wkmp(event.target).hasClass('mp-avg-rating-box-link')) {
			wkmp('.mp-avg-rating-box').toggle();
			wkmp(this).toggleClass('open')
		}
    });

    wkmp('body').on('click', function (event) {
        if (wkmp('.mp-avg-rating-box-link').hasClass('open')) {
            wkmp('.mp-avg-rating-box-link').removeClass('open');
            wkmp('.mp-avg-rating-box').toggle();
        }

    });

	wkmp('body').on('click', '.mp-seller-review-form p.mp-star-rating a', function () {
		var feedType = wkmp(this).data('type');
		var $star = wkmp(this),
			$rating = wkmp(this).closest('.mp-star-rating').siblings('#feed-' + feedType + '-rating'),
			$container = wkmp(this).closest('.mp-star-rating');

		$rating.val($star.data('rate'));
		$star.siblings('a').removeClass('active');
		$star.addClass('active');
		$container.addClass('selected');

		return false
	});
});

wkmp(function () {

	if (wkmp('.wkmp-role-selector').length) {
		wkmp('.wkmp-role-selector li').on('click', function (e) {
			let thisElm = wkmp(this);
			thisElm.addClass('active').siblings().removeClass('active');
			if (1 == thisElm.data('target')) {
				wkmp('.wkmp-show-fields-if-seller').slideDown();
				wkmp('.wkmp-show-fields-if-seller').find(':input').removeAttr('disabled');
			} else {
				wkmp('.wkmp-show-fields-if-seller').find(':input').attr('disabled', 'disabled');
				wkmp('.wkmp-show-fields-if-seller').slideUp();
			}
		});
	}

	if (wkmp('#wkmp-shopname').length) {
		wkmp('#wkmp-shopname').on('focusout', function (e) {
			wkmp(this).next('.wkmp-error').remove();
			let value = wkmp(this).val().toLowerCase().replace(/-+/g, '').replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
			wkmp('#wkmp-shopurl').val(value);
		});

		wkmp('#wkmp-shopurl').on('focusout', function () {
			let self = wkmp(this);
            wkmp(self).next('.wkmp-error').remove();
            let shop_slug = self.val();
            if ('' === shop_slug){
                return false;
            }

			wkmp.ajax({
				type: 'POST',
				url: wkmpObj.ajax.ajaxUrl,
				data: {
					action: "wkmp_check_shop_url",
					shop_slug: shop_slug,
					wkmp_nonce: wkmpObj.ajax.ajaxNonce,
				},
				success: function (response) {
					if (false === response.error) {
						wkmp('#wkmp-shop-url-availability').removeClass('wkmp-text-danger').addClass('wkmp-text-success').text(response.message);
					} else {
						wkmp('#wkmp-shop-url-availability').removeClass('wkmp-text-success').addClass('wkmp-text-danger').text(response.message);
					}
				}
			});
		});
	}

	if (wkmp('.woocommerce-form-register').length) {
		wkmp('form.woocommerce-form-register').on('submit', function (e) {
			wkmp('.wkmp-error').remove();
			let role = wkmp('input[name=role]:checked').val();

			if ('seller' === role) {
				let form = wkmp(this).find('input');
				let errorDiv = wp.template('wkmp_field_empty');

				wkmp.each(form, function (i, elm) {
					if ('' === wkmp(elm).val() && false === wkmp(elm).parents().hasClass('w3eden')) {
						e.preventDefault();
						wkmp(wkmp(elm)[0]).after(errorDiv());
					}
				});
			}
		});
	}

	/**
	 * Js for tabs
	 */
	wkmp('.wkmp_nav_tabs li a:not(:first)').addClass('inactive');
	wkmp('.wkmp_tab_content .wkmp_tab_pane:not(:first)').addClass('wkmp_hide');

	wkmp('.wkmp_nav_tabs li a').on('click', function () {

		wkmp('.wkmp_nav_tabs li a').removeClass('active').addClass('inactive');
		wkmp(this).removeClass('inactive').addClass('active');

		let id = wkmp(this).data('id');

		wkmp('.wkmp_tab_content .wkmp_tab_pane').removeClass('wkmp_show').addClass('wkmp_hide');
		wkmp(`.wkmp_tab_content ${id}`).removeClass('wkmp_hide').addClass('wkmp_show');

	});


	// variation attribute
	wkmp(document).on('click', '#mp_var_attribute_call', function (event) {
		event.preventDefault();
		var pid = wkmp('#sell_pr_id').val();
		wkmp.ajax({
			type: 'POST',
			url: wkmpObj.ajax.ajaxUrl,
			data: {
				action: "wkmp_marketplace_attributes_variation",
				product: pid,
				wkmp_nonce: wkmpObj.ajax.ajaxNonce,
			},
			beforeSend: function () {
				wkmp('#mp-loader').css('display', 'block');
			},
			success: function (data) {
				wkmp('#mp-loader').css('display', 'none');
				wkmp('#mp_attribute_variations').append(data);
			}
		});
	});
	// Add product related code end here

	/**
	 * Open the modal for seller ask query
	 */
	wkmp('body').on('click', '#wkmp-ask-query', function () {
		let id = wkmp(this).data('modal_src');
		wkmp(id).css('display', 'block');
	});

	/**
	 * Close modal
	 */
	wkmp('body').on('click', '.wkmp-popup-modal .modal-footer .close-modal', function () {
		wkmp(this).parents('.wkmp-popup-modal').css('display', 'none');
	});

	// Seller profile Page related code start here
	wkmp('body').on('click', '#wkmp-upload-profile-image', function () {
		wkmp('#seller_avatar_file').trigger('click');
	});

	wkmp('body').on('change', '#seller_avatar_file', function () {
		var reader = new FileReader();
		reader.onload = function (e) {
			wkmp('.wkmp_profile_img #wkmp-thumb-image img').attr('src', e.target.result);
		};
		reader.readAsDataURL(this.files[0]);
	});

	wkmp('body').on('click', '.wkmp_profile_img .wkmp-remove-profile-image', function () {
		let img = wkmp(this).parents('.wkmp_profile_img').find('#wkmp-thumb-image img').data('placeholder-url');
		wkmp(this).parents('.wkmp_profile_img').find('#wkmp-thumb-image img').attr('src', img);
		wkmp(this).parents('.wkmp_profile_img').find('#thumbnail_id_avatar').val('');
	});

	wkmp('body').on('click', '#wkmp-upload-shop-logo', function () {
		wkmp('#seller_shop_logo_file').trigger('click');
	});

	wkmp('body').on('change', '#seller_shop_logo_file', function () {
		var reader = new FileReader();
		reader.onload = function (e) {
			wkmp('.wkmp_profile_logo #wkmp-thumb-image img').attr('src', e.target.result);
		};
		reader.readAsDataURL(this.files[0]);
	});

	wkmp('body').on('click', '.wkmp_profile_logo .wkmp-remove-shop-logo', function () {
		let img = wkmp(this).parents('.wkmp_profile_logo').find('#wkmp-thumb-image img').data('placeholder-url');
		wkmp(this).parents('.wkmp_profile_logo').find('#wkmp-thumb-image img').attr('src', img);
		wkmp(this).parents('.wkmp_profile_logo').find('#thumbnail_id_company_logo').val('');
	});

	wkmp('body').on('click', '#wkmp-upload-seller-banner', function () {
		wkmp('#wk_mp_shop_banner').trigger('click');
	});

	wkmp('body').on('change', '#wk_mp_shop_banner', function () {
		var reader = new FileReader();
		reader.onload = function (e) {
			wkmp('.wkmp_shop_banner img').attr('src', e.target.result);
		};
		reader.readAsDataURL(this.files[0]);
	});

	wkmp('body').on('click', '.wkmp_shop_banner #wkmp-remove-seller-banner', function () {
		let img = wkmp(this).parents('.wkmp_shop_banner').find('#wk_seller_banner img').data('placeholder-url');
		wkmp(this).parents('.wkmp_shop_banner').find('#wk_seller_banner img').attr('src', img);
		wkmp(this).parents('.wkmp_shop_banner').find('#thumbnail_id_shop_banner').val('');
	});
	// Seller profile Page related code end here.

	/**
	 * Checked all list on click all checked
	 */
	wkmp('body').on('click', '#wkmp-checked-all', function () {
		if (true == wkmp(this).prop("checked")) {
			wkmp('input[name*=\'selected\']').prop('checked', true);
		} else {
			wkmp('input[name*=\'selected\']').prop('checked', false);
		}
	});

	wkmp('body').on('click', '.wkmp-bulk-delete', function () {
		let form_id = wkmp(this).data('form_id');
		let flag = false;
		wkmp(`${form_id} input[type=\'checkbox\']`).each(function () {
			if (wkmp(this).is(':checked')) {
				flag = true;
			}
		});
		if (flag) {
			confirm('Are you sure..?') ? wkmp(form_id).submit() : false;
		} else {
			alert('Please select first');
		}
	});


	wkmp('body').on('click', '#wkmp-send-notification', function () {
		let customer_ids = [];

		wkmp(`#wkmp-followers-list input[type=\'checkbox\']`).each(function () {
			if (wkmp(this).is(':checked')) {
				customer_ids.push(wkmp(this).val());
			}
		});

		if ('on' === customer_ids[0]) {
			customer_ids.shift();
		}

		if (customer_ids.length >= 1) {
			for (var i = 0; i < customer_ids.length; i++) {
				wkmp('#wkmp-seller-send-notification #wkmp-seller-sendmail-form').append(`<input type="hidden" name="customer_ids[]" value="${customer_ids[i]}"/>`);
			}
			wkmp('#wkmp-seller-send-notification').css('display', 'block');

		} else {
			alert('Please select first');
		}

	});

	wkmp('body').on('click', '#wkmp-add-seller-as-favourite', function () {
		let seller_id = wkmp(this).find('input[name="wkmp_seller_id"]').val();
        let customer_id = wkmp(this).find('input[name="wkmp_customer_id"]').val();

        wkmp('.wkmp-spin-loader').removeClass('wkmp_hide');
		wkmp.ajax({
			type: 'POST',
			url: wkmpObj.ajax.ajaxUrl,
			data: {
				action: "wkmp_add_favourite_seller",
				seller_id: seller_id,
				customer_id: customer_id,
				wkmp_nonce: wkmpObj.ajax.ajaxNonce,
			},
            success: function (json) {
                wkmp('.wkmp-spin-loader').addClass('wkmp_hide');
				if ('added' === json['success']) {
                    wkmp('#wkmp-add-seller-as-favourite .dashicons-heart').css('color', '#96588a');
				}
				if ('removed' === json['success']) {
					wkmp('#wkmp-add-seller-as-favourite .dashicons-heart').css('color', 'unset');
                }
                wkmp('.woocommerce .wkmp-confirmation-msg').html(json.message).css('display','block');
                setTimeout(function () {
                    wkmp('.woocommerce .wkmp-confirmation-msg').css('display','none');
                },3000);
			}
		});
	});

	wkmp('body').on('click', '.mp-rating-input .stars a', function () {
		let curr_obj = wkmp(this).parents('.mp-rating-input');
		let rate = wkmp(this).text();
		curr_obj.find('.stars').find('a').removeClass('active');
		curr_obj.find('.stars').addClass('selected');
		curr_obj.find('.stars').find(`.star-${rate}`).addClass('active');
		let id = curr_obj.data('id');
		wkmp(`${id} option:selected`).removeAttr("selected");
		wkmp(`${id} option:eq(${rate})`).attr("selected", "selected");
	});

	wkmp('#mp-update-sale-order').on('change', function (evt) {
		evt.preventDefault();
		wkmp(window).scrollTop(0);
		wkmp('body').append('<div class="wk-mp-loader"><div class="wk-mp-spinner wk-mp-skeleton"><!--////--></div></div>');
		wkmp('.wk-mp-loader').css('display', 'inline-block');
		wkmp('body').css('overflow', 'hidden');
		setTimeout(function () {
			wkmp('body').css('overflow', 'auto');
			wkmp('.wk-mp-loader').remove()
		}, 1500)
	});

	wkmp('#wkmp-seller-profile #billing-country').on('change', function (evt) {
        let code = wkmp(this).val();
		wkmp.ajax({
			type: 'POST',
			url: wkmpObj.ajax.ajaxUrl,
			data: {
				action: "wkmp_get_state_by_country_code",
				country_code: code,
				wkmp_nonce: wkmpObj.ajax.ajaxNonce,
			},
			success: function (json) {
				if (json['success']) {
					wkmp('#wkmp-seller-profile #billing-state').replaceWith(json['html']);
				}

			}
		});
	});

	/* product status downloadable file */
	var file_path_field;

	wkmp('.wk-mp-side-body').on("click", '.upload_downloadable_file', function (event) {
		var file_frame;
		var $el = wkmp(this);
		file_path_field = $el.closest('tr').find('td.file_url input');
		event.preventDefault();

		// If the media frame already exists, reopen it.
		if (file_frame) {
			file_frame.open();
			return;
		}

		// Create the media frame.
		file_frame = wp.media.frames.file_frame = wp.media({
			title: $el.data('choose'),
			button: {
				text: $el.data('update')
			},
			multiple: false  // Set to true to allow multiple files to be selected.
		});

		// When frame is open, select existing image attachments from custom field.
		file_frame.on('open', function () {
			var selection = file_frame.state().get('selection');
		});

		var query = wp.media.query();

		query.filterWithIds = function (ids) {
			return _(this.models.filter(function (c) {
				return _.contains(ids, c.id);
			}));
		};

		var res = query.filterWithIds([3]); // change these to your IDs.

		res.each(function (v) {
			console.log(v.toJSON());
		});

		// When images are selected, place IDs in hidden custom field and show thumbnails.

		file_frame.on('select', function () {
			var file_path = '';
			var selection = file_frame.state().get('selection');

			// Place IDs in custom field.

			var attachment_ids = selection.map(function (attachment) {
				attachment = attachment.toJSON();
				if (attachment.url) {
					file_path = attachment.url;
				}
				file_path_field.val(file_path).change();
				return attachment.id;
			});
		});

		// Finally, open the modal

		file_frame.open();
	});

	wkmp(".select-group .dropdown-togle").on("click", function () {
		wkmp(this).parent().toggleClass("open");
	});

	wkmp('.wkmp-order-refund-button').on('click', (e) => {
		wkmp('.wkmp-order-refund').toggle();
		if ('table-cell' === wkmp('.wkmp-order-refund').css('display')) {
			wkmp(e.target).text('Cancel');
		} else {
			wkmp(e.target).text('Refund');
		}
	});

	if (wkmp('.refund_line_total')) {
		wkmp('.refund_line_total').on('change', (e) => {
			let refundTotal = 0;
			document.querySelectorAll('.refund_line_total').forEach((input) => {
				let qty = 0;
				if (input.type === 'checkbox' && input.checked) {
					qty = input.value;
				} else if (input.type !== 'checkbox') {
					qty = input.value;
				}
				refundTotal += qty * input.previousElementSibling.value;
			});
			document.querySelector('#refund-amount').value = Math.round(refundTotal * 100) / 100;
		});
	}

	//Add product start here.
	wkmp(document).on('click', '#wk_stock_management', function () {
		if (wkmp(this).is(':checked')) {
			wkmp('.wkmp_profile_input #wk-mp-stock-qty').parent('.wkmp_profile_input').css('display', 'block')
			wkmp('.wkmp_profile_input #_backorders').parent('.wkmp_profile_input').css('display', 'block')
			wkmp('.wkmp_profile_input #_stock_status').parent('.wkmp_profile_input').css('display', 'none')
		} else {
			wkmp('.wkmp_profile_input #wk-mp-stock-qty').parent('.wkmp_profile_input').css('display', 'none')
			wkmp('.wkmp_profile_input #_backorders').parent('.wkmp_profile_input').css('display', 'none')
			wkmp('.wkmp_profile_input #_stock_status').parent('.wkmp_profile_input').css('display', 'block')
		}
	});

	wkmp('.mp-toggle-sider-edit,.mp-toggle-save').on('click', function () {
		var status = wkmp('#product_post_status').val();
		if ('publish' === status) {
			wkmp('.mp-toggle-selected-display').html(wkmpObj.mkt_tr.mkt28);
		} else {
			wkmp('.mp-toggle-selected-display').html(status);
		}
		wkmp('.wkmp-toggle-select-container').toggle()
	});

	wkmp('a.mp-toggle-cancel').on('click', function () {
		wkmp('.wkmp-toggle-select-container').hide();
	});

	// Product type sidebar.
	var product_type = wkmp('#product_type').val();

	var var_type = wkmp('#var_variation_display').val();
	if ('variable' === product_type && 'yes' === var_type) {
		wkmp("#edit_product_tab li").eq(6).show();
	}

	if ('external' === product_type) {
		wkmp("#edit_product_tab li").eq(5).show();
	}

	wkmp(document).on('change', 'body #product_type', function () {
		var product_type = wkmp('#product_type').val();
		var var_type = wkmp('#var_variation_display').val();

		if ('variable' === product_type && 'yes' === var_type) {
			wkmp("#edit_product_tab li").eq(6).show();
		} else {
			wkmp("#edit_product_tab li").eq(6).hide();
		}

		if ('simple' === product_type) {
			wkmp('#regularPrice').show();
			wkmp('#salePrice').show();
		} else {
			wkmp('#regularPrice').hide();
			wkmp('#salePrice').hide();
		}

		if ('external' === product_type) {
			wkmp("#edit_product_tab li").eq(5).show();
		} else {
			wkmp("#edit_product_tab li").eq(5).hide();
		}
	});

	wkmp('a.mp-toggle-type-cancel').on('click', function () {
		wkmp('.mp-toggle-select-type-container').css('display', 'none');
	});

	wkmp('.mp_value_asc').change(function () {
		var str = wkmp(this).val();
		var newUrl = window.location.href + '&' + str;
		window.location = newUrl;
	});

	//downloadable check
	wkmp('#_ckdownloadable').change(function () {
		wkmp('.wk-mp-side-body').slideToggle("slow");
	});

	wkmp('#_ckvirtual').change(function () {
		if ('none' !== wkmp("#edit_product_tab li").eq(2).css('display')) {
			wkmp("#edit_product_tab li").eq(2).css('display', 'none');
		} else {
			wkmp("#edit_product_tab li").eq(2).css('display', 'block');
		}
	});

	/***********Seller multiple downloadable files starts***********/

	wkmp('.wk-mp-side-body').on('click', '.downloadable_files a.insert', function () {
		wkmp(this).closest('.downloadable_files').find('tbody').append(wkmp(this).data('row'));
		return false;
	});

	wkmp('.wk-mp-side-body').on('click', '.downloadable_files a.delete', function () {
		wkmp(this).closest('tr').remove();
		return false;
	});

	/***********Seller multiple downloadable files ends***********/

	wkmp(document).on('change', '.checkbox_is_virtual', function () {
		wkmp(this).parents('tbody').children('tr').eq(0).find('.virtual').slideToggle('fast');
	});

	wkmp(document).on('change', '.checkbox_is_downloadable', function () {
		wkmp(this).parents('tbody').children('tr').eq(0).find('.downloadable').slideToggle('fast');
	});
	wkmp(document).on('change', '.checkbox_manage_stock', function () {
		wkmp(this).parents('tbody').children('tr').eq(0).find('.wkmp_stock_status').slideToggle('fast');
	});
	// upload file name handler

	//upload button for product image file
	wkmp('.add-mp-product-images').on('click', function (event) {
		var file_frame;
		var image_id = wkmp(this).attr('id');
		var image_id_field = wkmp('#product_image_Galary_ids').val();
		var galary_ids = '';
		var typeError = 0;

		wkmp('#wk-mp-product-images').find('.error-class').remove();

		if ('' === image_id_field) {
			galary_ids = '';
		} else {
			galary_ids = image_id_field + ',';
		}

		event.preventDefault();
		// If the media frame already exists, reopen it.
		if (file_frame) {
			file_frame.open();
			return;
		}

		// Create the media frame.
		file_frame = wp.media.frames.file_frame = wp.media({
			title: wkmp(this).data('uploader_title'),
			button: {text: wkmp(this).data('uploader_button_text')},
			multiple: true  // Set to true to allow multiple files to be selected
		});

		// When frame is open, select existing image attachments from custom field
		file_frame.on('open', function () {
			var selection = file_frame.state().get('selection');
		});

		var query = wp.media.query();

		query.filterWithIds = function (ids) {
			return _(this.models.filter(function (c) {
				return _.contains(ids, c.id);
			}));
		};

		// When images are selected, place IDs in hidden custom field and show thumbnails.
		file_frame.on('select', function () {
			var selection = file_frame.state().get('selection');
			// Place IDs in custom field
			var attachment_ids = selection.map(function (attachment) {
				attachment = attachment.toJSON();

				if (undefined !== attachment.sizes) {
					galary_ids = galary_ids + attachment.id + ',';
					wkmp('#handleFileSelectgalaray').append("<img src='" + attachment.sizes.thumbnail.url + "' width='50' height='50'/>");
					return attachment.id;
				} else {
					typeError = 1;
				}
			});

			if (typeError) {
				wkmp('#wk-mp-product-images').append("<p class=error-class>" + wkmp(".mp_product_thumb_image.button").data('type-error') + "</p>");
			}

			galary_ids = galary_ids.replace(/,\s*$/, "");
			wkmp('#product_image_Galary_ids').val(galary_ids);

		});

		// Finally, open the modal
		file_frame.open();
	});

	/* mp thumb image */
	wkmp('.mp_product_thumb_image').on('click', function (event) {
		var file_frame;

		event.preventDefault();

		if (file_frame) {
			file_frame.open();
			return;
		}

		// Create the media frame.
		file_frame = wp.media.frames.file_frame = wp.media({
			title: wkmp(this).data('uploader_title'),
			button: {text: wkmp(this).data('uploader_button_text')},
			multiple: false  // Set to true to allow multiple files to be selected
		});

		// When frame is open, select existing image attachments from custom field
		file_frame.on('open', function () {
			var selection = file_frame.state().get('selection');
		});

		var query = wp.media.query();

		query.filterWithIds = function (ids) {
			return _(this.models.filter(function (c) {
				return _.contains(ids, c.id);
			}));
		};

		// When images are selected, place IDs in hidden custom field and show thumbnails.
		file_frame.on('select', function () {
			var selection = file_frame.state().get('selection');
			// Place IDs in custom field
			var attachment_ids = selection.map(function (attachment) {
				attachment = attachment.toJSON();
				wkmp(".mp_product_thumb_image.button").siblings('.error-class').remove();

				if (undefined !== attachment.sizes) {
					wkmp('#product_thumb_image_mp').val(attachment.id);
					wkmp('#mp-product-thumb-img-div').find("img").attr('src', attachment.sizes.thumbnail.url);

					if (wkmp('#mp-product-thumb-img-div').find("span").length <= 0) {
						wkmp('#mp-product-thumb-img-div').append('<span style="right: -20px;top: -12px;" title="Remove" class="mp-image-remove-icon">x</span>');
					}

					return attachment.id;
				} else {
					wkmp(".mp_product_thumb_image.button").parent().append("<p class=error-class>" + wkmp(".mp_product_thumb_image.button").data('type-error') + "</p>");
				}
			});

		});

		// Finally, open the modal
		file_frame.open();
	});

	/* mp thumb image end */

	/* remove thumb image product */
	wkmp('#mp-product-thumb-img-div').on('click', '.mp-image-remove-icon', function () {
		wkmp('#product_thumb_image_mp').val('');
		wkmp(this).siblings('img').attr('src', wkmp(this).siblings('img').data('placeholder-url'));
		wkmp(this).remove();
	});

	// tabs on edit product page
	wkmp('#edit_product_tab li a:not(:first)').addClass('inactive');

	if (!wkmp('#edit_notification_tab li a').length) {
		wkmp('.wkmp_container').hide();
		wkmp('.wkmp_container:first').show();
	}

	var activeproducttab = wkmp('#active_product_tab');
	if (activeproducttab.val()) {
		var activeproducttabvalue = activeproducttab.val();
		if (wkmp('#' + activeproducttabvalue).hasClass('inactive')) {
			wkmp('#edit_product_tab li a').addClass('inactive');
			wkmp('#' + activeproducttabvalue).removeClass('inactive');

			wkmp('.wkmp_container').hide();
			wkmp('#' + wkmp('#' + activeproducttabvalue).attr('id') + 'wk').fadeIn('slow');
		}
	}

	wkmp('#edit_product_tab li a').click(function () {
		var t = wkmp(this).attr('id');
		activeproducttab.val(t);
		if (wkmp(this).hasClass('inactive')) { //this is the start of our condition
			wkmp('#edit_product_tab li a').addClass('inactive');
			wkmp(this).removeClass('inactive');

			wkmp('.wkmp_container').hide();
			wkmp('#' + t + 'wk').fadeIn('slow');
		}
	});

	wkmp('#edit_notification_tab li a').click(function () {
		var t = wkmp(this).attr('id');
		if (wkmp(this).hasClass('inactive')) { //this is the start of our condition
			wkmp('#edit_notification_tab li a').addClass('inactive');
			wkmp(this).removeClass('inactive');

			wkmp('.wkmp_container').hide();
			wkmp('#' + t + 'wk').fadeIn('slow');
		}
	});
	//attribute dynamic fields
	var wrapper = wkmp(".wk_marketplace_attributes");
	var add_button = wkmp(".add-variant-attribute");
	var attribute_no = wkmp("div.wk_marketplace_attributes > div.wkmp_attributes").length;
	var x = attribute_no;

	wkmp(document).on('click', '.add-variant-attribute', function (e) {
		e.preventDefault();
		var type = wkmp('#sell_pr_type').val();
		if ('variable' === type) {
			var html = '';
			html += '<div class="wkmp_attributes">';
			html += '<div class="box-header attribute-remove">';
			html += '<input type="text" class="mp-attributes-name wkmp_product_input" placeholder="' + wkmpObj.mkt_tr.mkt29 + '" name="pro_att[' + x + '][name]" value=""/>';
			html += '<input type="text" class="option wkmp_product_input" title="' + wkmpObj.mkt_tr.mkt30 + '" placeholder="' + wkmpObj.mkt_tr.mkt31 + '" name="pro_att[' + x + '][value]" />';
			html += '<input type="hidden" name="pro_att[' + x + '][position]" class="attribute_position" value="1"/>';
			html += '<span class="mp_actions">';
			html += '<button class="mp_attribute_remove btn btn-danger" type="button">' + wkmpObj.mkt_tr.mkt32 + '</button>';
			html += '</span>';
			html += '</div>';
			html += '<div class="box-inside clearfix">';
			html += '<div class="wk-mp-attribute-config">';
			html += '<div class="wkmp-checkbox-inline">';
			html += '<input type="checkbox" class="checkbox" name="pro_att[' + x + '][is_visible]" id="is_visible_page' + x + '" value="1"/>';
			html += '<label for="is_visible_page' + x + '">' + wkmpObj.mkt_tr.mkt33 + '</label>';
			html += '</div>';
			html += '<div class="wkmp-checkbox-inline">';
			html += '<input type="checkbox" class="checkbox" name="pro_att[' + x + '][is_variation]" id="product_att_varition_' + x + '" value="1"/>';
			html += '<label for="product_att_varition_' + x + '">' + wkmpObj.mkt_tr.mkt34 + '</label>';
			html += '</div>';
			html += '<input type="hidden" name="pro_att[' + x + '][is_taxonomy]" value="0"/>';
			html += '</div>';
			html += '<div class="attribute-options"></div>';
			html += '</div>';
			html += '</div>';
			wkmp(wrapper).append(html);
		} else {
			var html = '';
			html += '<div class="wkmp_attributes">';
			html += '<div class="box-header attribute-remove">';
			html += '<input type="text" class="mp-attributes-name wkmp_product_input" placeholder="' + wkmpObj.mkt_tr.mkt29 + '" name="pro_att[' + x + '][name]" value=""/>';
			html += '<input type="text" class="option wkmp_product_input" title="' + wkmpObj.mkt_tr.mkt30 + '" placeholder="' + wkmpObj.mkt_tr.mkt31 + '" name="pro_att[' + x + '][value]" />';
			html += '<input type="hidden" name="pro_att[' + x + '][position]" class="attribute_position" value="1"/>';
			html += '<span class="mp_actions">';
			html += '<button class="mp_attribute_remove btn btn-danger" type="button">' + wkmpObj.mkt_tr.mkt32 + '</button>';
			html += '</span>';
			html += '</div>';
			html += '<div class="box-inside clearfix">';
			html += '<div class="wk-mp-attribute-config">';
			html += '<div class="wkmp-checkbox-inline">';
			html += '<input type="checkbox" class="checkbox" name="pro_att[' + x + '][is_visible]" id="is_visible_page' + x + '" value="1"/>';
			html += '<label for="is_visible_page' + x + '">' + wkmpObj.mkt_tr.mkt33 + '</label>';
			html += '</div>';
			html += '<input type="hidden" name="pro_att[' + x + '][is_taxonomy]" value="0"/></div><div class="attribute-options">';
			html += '</div>';
			html += '</div>';
			html += '</div>';
			wkmp(wrapper).append(html);
		}
		x++;
	});

	wkmp(".wk_marketplace_attributes").on("click", ".mp_attribute_remove", function (e) { //user click on remove text
		e.preventDefault();
		wkmp(this).parent().parent().parent().remove();
	});

	wkmp('#mp_attribute_variations').on("click", ".mp_attribute_remove", function (e) { //user click on remove text
		e.preventDefault();
		wkmp(this).parent().parent().remove();
		var var_att_id = wkmp(this).data('var_id');
		wkmp.ajax({
			type: 'POST',
			url: wkmpObj.ajax.ajaxUrl,
			data: {"action": "wkmp_attributes_variation_remove", "var_id": var_att_id, "wkmp_nonce": wkmpObj.ajax.ajaxNonce},
			success: function (data) {
				wkmp('#wkmp_remove_notice_wrap').removeClass('wkmp_hide').html(data.msg);
				if (!data.success) {
					wkmp('#wkmp_remove_notice_wrap').addClass('woocommerce-error');
				}
			}
		});
	});

	wkmp('.wkmp_variation_downloadable_file').on("click", '.mp_var_del', function () {
		var del_id = wkmp(this).attr('id');
		wkmp('#' + del_id).parent().parent().remove();
	});

	wkmp('#mp_attribute_variations').on("click", ".upload_image_button", function () {
		var file_type_id = wkmp(this).attr('id') + 'upload';
		wkmp('#' + file_type_id).trigger('click');
	});

	wkmp(document).on("click", '#mp_attribute_variations div.wkmp_variation_downloadable_file .wkmp_downloadable_upload_file', function (event) {
		event.preventDefault();
		var trigger_id = wkmp(this).attr('id');
		// var up_id=trigger_id.split('_');
		var text_box_file_url = 'downloadable_upload_file_url_' + trigger_id;
		var file_frame;
		// If the media frame already exists, reopen it.
		if (file_frame) {
			file_frame.open();
			return;
		}

		// Create the media frame.
		file_frame = wp.media.frames.file_frame = wp.media({
			title: wkmp(this).data('uploader_title'),
			button: {text: wkmp(this).data('uploader_button_text')},
			multiple: false  // Set to true to allow multiple files to be selected
		});

		// When frame is open, select existing image attachments from custom field
		file_frame.on('open', function () {
			var selection = file_frame.state().get('selection');
		});
		var query = wp.media.query();

		query.filterWithIds = function (ids) {
			return _(this.models.filter(function (c) {
				return _.contains(ids, c.id);
			}));
		};

		var res = query.filterWithIds([3]); // change these to your IDs

		res.each(function (v) {
			console.log(v.toJSON());
		});

		// When images are selected, place IDs in hidden custom field and show thumbnails.
		file_frame.on('select', function () {

			var selection = file_frame.state().get('selection');

			// Place IDs in custom field
			var attachment_ids = selection.map(function (attachment) {
				attachment = attachment.toJSON();
				wkmp('#' + text_box_file_url).val(attachment.url);
				return attachment.id;
			});
		});

		// Finally, open the modal
		file_frame.open();
	});

	// variation attribute


	// multiple thumb image upload and view
	function handleFileSelect(evt) {
		wkmp('#product_image').empty();
		var files = evt.target.files; // FileList object
		// Loop through the FileList and render image files as thumbnails.
		for (var i = 0, f; f = files[i]; i++) {
			// Only process image files.
			if (!f.type.match('image.*')) {
				continue;
			}
			var reader = new FileReader();
			// Closure to capture the file information.
			reader.onload = (function (theFile) {
				return function (e) {
					// Render thumbnail.
					var div = document.createElement('div');
					//wkmp(div).attr({class:'ingdiv'});
					div.innerHTML = ['<img class="thumb" src="', e.target.result, '" title="', escape(theFile.name), '"/><span class="wkmp_image_over" ></span><input type="hidden" name ="mpthumbimg[]" value="', escape(theFile.name), '">'].join('');
					document.getElementById('product_image').insertBefore(div, null);
					wkmp('#product_image div').attr({class: 'imgdiv'});
					wk_imgview();
				};
			})(f);
			// Read in the image file as a data URL.
			reader.readAsDataURL(f);
		}

		function wk_imgview() {
			wkmp('div.imgdiv').mouseover(function (event) {
				//alert('Hello div');
				wkmp(this).find(".wkmp_image_over").css({display: "block"});
				wkmp(this).find("img").css("opacity", "0.4");
				wkmp(this).find(".wkmp_image_over").on('click', function () {
					wkmp(this).parent("div").remove();
				});
			});

			wkmp("div.imgdiv").mouseout(function (event) {
				wkmp(this).find(".wkmp_image_over").css({display: "none"});
				wkmp(this).find("img").css("opacity", "1");
			});
		}
	}

	// multiple galary image upload and view
	function handleFilegalaray(evt) {
		wkmp('#handleFileSelectgalaray').empty();
		var files = evt.target.files; // FileList object
		// Loop through the FileList and render image files as thumbnails.
		for (var i = 0, f; f = files[i]; i++) {
			// Only process image files.
			if (!f.type.match('image.*')) {
				continue;
			}
			var reader = new FileReader();
			// Closure to capture the file information.
			reader.onload = (function (theFile) {
				return function (e) {
					// Render thumbnail.
					var div = document.createElement('div');
					div.innerHTML = ['<img class="thumb" src="', e.target.result, '" title="', escape(theFile.name), '"/><span class="wkmp_image_over" ></span><input type="hidden" name ="mpproductgall[]" value="', escape(theFile.name), '">'].join('');
					document.getElementById('handleFileSelectgalaray').insertBefore(div, null);
					wkmp('#handleFileSelectgalaray div').attr({class: 'imgdiv'});
					wk_imgview();
				};
			})(f);
			// Read in the image file as a data URL.
			reader.readAsDataURL(f);
		}

		function wk_imgview() {
			wkmp('div.imgdiv').mouseover(function (event) {
				//alert('Hello div');
				wkmp(this).find(".wkmp_image_over").css({display: "block"});
				wkmp(this).find("img").css({"opacity": "0.4"});
				// For Delete the image  Div at Click on Cross Icon
				wkmp(this).find(".wkmp_image_over").on('click', function () {
					wkmp(this).parent("div").remove();
				});

			});

			wkmp("div.imgdiv").mouseout(function (event) {
				wkmp(this).find(".wkmp_image_over").css({display: "none"});
				wkmp(this).find("img").css({"opacity": "1"});
			});

		}
	}

	// deleting image
	wkmp('a.mp-img-delete_gal').click(function () {
		wkmp('#' + this.id).parent().remove();
		wkmp.ajax({
			type: 'POST',
			url: wkmpObj.ajax.ajaxUrl,
			data: {
				"action": "wkmp_productgallary_image_delete",
				"img_id": this.id,
				"wkmp_nonce": wkmpObj.ajax.ajaxNonce
			},
			success: function (data) {
				wkmp('#product_image_Galary_ids').val(data);
			}
		});
	});

	wkmp('#mp_attribute_variations').on("click", ".mp_varnew_file", function () {
		var var_did = wkmp(this).attr('id');
		var variation_count = wkmp("div#variation_downloadable_file_" + var_did + " > div").length;
		var wrapper = '#variation_downloadable_file_' + var_did;
		wkmp.ajax({
			type: 'POST',
			url: wkmpObj.ajax.ajaxUrl,
			data: {
				"action": "wkmp_downloadable_file_add",
				"var_id": var_did,
				"eleme_no": variation_count,
				"wkmp_nonce": wkmpObj.ajax.ajaxNonce
			},
			success: function (data) {
				wkmp(data).appendTo(wrapper);
			}
		});
	});

	//product validation
	wkmp('#add_product_sub').click(function (e) {
		if ('submit' === wkmp(this).attr('type')) {
			var product_name = wkmp('#product_name').val();
			product_name = trim_wkmp_value(product_name);
			var product_sku = wkmp('#product_sku').val();
			var regu_price = wkmp('#regu_price').val();

			var ck_name = /^[A-Za-z0-9 _-]{1,40}$/;
			var price = /^\d+(\.\d{1,2})?$/;
			var error = 0;
			if (0 === product_name.length) {
				wkmp('#pro_name_error').html(wkmpObj.mkt_tr.mkt2);
				error++;
			}

			if (typeof (product_sku) != 'undefined' && product_sku.length < 3) {
				wkmp('#pro_sku_error').css('color', 'red');
				wkmp('#pro_sku_error').html(wkmpObj.mkt_tr.mkt3);
				error++;
			}

			var pro_type = wkmp('input[name="product_type"]').val();

			if ('' === pro_type || 'undefined' === typeof pro_type) {
				pro_type = wkmp('#product_type').val();
			}

			if ('variable' !== pro_type && 'grouped' !== pro_type) {
				if (!wkmp.isNumeric(regu_price)) {
					wkmp('#regl_pr_error').html(wkmpObj.mkt_tr.mkt6);
					error++;
				} else {
					wkmp('#regl_pr_error').html('');
				}
			}

			var sale_price = wkmp('#sale_price').val();
			var regular = parseFloat(wkmp('#regu_price').val());
			var sale = parseFloat(wkmp('#sale_price').val());
			if (wkmp('#sale_price').val()) {
				if (!wkmp.isNumeric(sale_price)) {
					wkmp('#sale_pr_error').html(wkmpObj.mkt_tr.mkt6);
					error++;
				} else if (sale > regular) {
					wkmp('#sale_pr_error').html(wkmpObj.mkt_tr.mkt5);
					error++;
				} else {
					wkmp('#sale_pr_error').html('');
				}
			}
			var product_sku = wkmp('#product_sku').val();
			wkmp('.wkmp_variable_sku').each(function () {
				var wkmp_variable_sku = wkmp(this).val();
				var this_sel = this;
			});

			if (error) {
				return false;
			}
		}
	});

	function trim_wkmp_value(item) {
		item = wkmp.trim(item);
		return item;
	}

	//sku validation
	var ps = wkmp('#product_sku').val();

	wkmp('#product_sku').blur(function () {
		var product_sku = wkmp('#product_sku').val();
		wkmp('#pro_sku_error').html('');
		if (product_sku !== ps) {
			product_sku_validation(product_sku);
		}
	});

	function product_sku_validation(argument) {
		var product_sku = argument;
		var reg_sku = /^[a-z0-9A-Z]{1,20}$/;
		wkmp('#pro_sku_error').css('color', 'red');
		if ('' === product_sku) {
			wkmp('#pro_sku_error').html(wkmpObj.mkt_tr.mkt4);
			return false;
		} else if (!reg_sku.test(product_sku)) {
			// wkmp('#pro_sku_error').html('special character and space are not allowed');
			//   return false;
		} else if ('undefined' !== typeof (product_sku) && product_sku.length < 3) {
			wkmp('#pro_sku_error').css('color', 'red');
			wkmp('#pro_sku_error').html(wkmpObj.mkt_tr.mkt3);
			return false;
		} else {
			wkmp('#pro_sku_error').html('');
        }

        wkmp('#add_product_sub').attr('disabled', 'disabled');
		wkmp.ajax({
			type: 'POST',
			url: wkmpObj.ajax.ajaxUrl,
			dataType: "json",
			data: {
				"action": "wkmp_product_sku_validation",
				"psku": product_sku,
				"wkmp_nonce": wkmpObj.ajax.ajaxNonce
			},
			success: function (data) {
				if (data && data.success === true) {
					wkmp('#pro_sku_error').css('color', 'green');
					wkmp('#pro_sku_error').html(data.message);
					wkmp('#add_product_sub').removeAttr('disabled');
				} else {
					wkmp('#pro_sku_error').css('color', 'red');
					wkmp('#pro_sku_error').html(data.message);
				}
			}
		});
	}

	// variation sku validation
	wkmp(document).on('blur', '.wkmp_variable_sku', function () {
		var wkmp_variable_sku = wkmp(this).val();
		var this_sel = this;
		wkmp(this).siblings('.wk_variable_sku_err').html('');
		if (wkmp(this).val() !== wkmp(this).attr('placeholder')) {
			variation_sku_validation(wkmp_variable_sku, this_sel);
		}
	});

	function variation_sku_validation(argument1, argument2) {
		var wkmp_variable_sku = argument1;
		var reg_sku = /^[a-z0-9A-Z]{1,20}$/;
		var this_sel = argument2;
		wkmp(this_sel).siblings('.wk_variable_sku_err').css('color', 'red');
		if ('' === wkmp_variable_sku) {
			wkmp(this_sel).siblings('.wk_variable_sku_err').html(wkmpObj.mkt_tr.mkt4);
			return false;
		} else if (!reg_sku.test(wkmp_variable_sku)) {
			// wkmp(this_sel).siblings('.wk_variable_sku_err').html('special character and space are not allowed');
			// return false;
		} else {
			wkmp(this_sel).siblings('.wk_variable_sku_err').html('');
		}
		wkmp.ajax({
			type: 'POST',
			url: wkmpObj.ajax.ajaxUrl,
			dataType: "json",
			data: {"action": "wkmp_product_sku_validation", "psku": wkmp_variable_sku, "wkmp_nonce": wkmpObj.ajax.ajaxNonce},
			success: function (data) {
				if (data && data.success === true) {
					wkmp(this_sel).siblings('.wk_variable_sku_err').css('color', 'green');
					wkmp(this_sel).siblings('.wk_variable_sku_err').html(data.message);
				} else {
					wkmp(this_sel).siblings('.wk_variable_sku_err').css('color', 'red');
					wkmp(this_sel).siblings('.wk_variable_sku_err').html(data.message);
					return false;
				}
			}
		});
	}

	// variation regular price validation
	wkmp(document).on('blur', '.wc_input_price', function () {
		var no = wkmp(this).val();
		wkmp(this).next('.error-class').remove()
		if (no && !wkmp.isNumeric(no)) {
			wkmp(this).after('<span class="error-class">' + wkmpObj.mkt_tr.mkt6 + '</span>')
		}
	});

	// variation weight price validation
	wkmp(document).on('blur', '.wc_input_decimal, #wk-mp-stock-qty', function () {
		var no = wkmp(this).val();
		wkmp(this).parent('.wrap').children('.error-class').remove()
		if (no && !wkmp.isNumeric(no)) {
			wkmp(this).parent('.wrap').append('<span class="error-class">' + wkmpObj.mkt_tr.mkt7 + '</span>')
		}
	});

	// stock
	wkmp(document).on('blur', '._weight_field .wc_input_decimal, #wk-mp-stock-qty', function () {
		var no = wkmp(this).val();
		wkmp(this).next('.error-class').remove()
		if (no && !wkmp.isNumeric(no)) {
			wkmp(this).after('<span class="error-class">' + wkmpObj.mkt_tr.mkt7 + '</span>')
		}
	});
	// variation weight price validation
	wkmp(document).on('keyup', '.wkmp_variable_stock', function () {
		var no = wkmp(this).val();
		var no_int = no;
		var stock = /^\d+(\.\d{1,2})?$/;
		a = no_int;
		if (no == no_int) {
			a = no_int;
		}
		if ('' !== wkmp(this).val() && stock.test(a)) {
			wkmp(this).val(a);
		} else {
			wkmp(this).val('');
			a = 0;
		}
	});
	//product name valdiation
	wkmp('#product_name').blur(function () {
		var product_name = wkmp('#product_name').val();
		var ck_name = /^[A-Za-z0-9 _-]{1,40}$/;
		if ('' === product_name) {
			wkmp('#pro_name_error').html(wkmpObj.mkt_tr.mkt8);
			return false;
		} else {
			wkmp('#pro_name_error').html('');
		}
	});
	//product regular price validation
	wkmp('#regu_price').blur(function () {
		var regu_price = wkmp('#regu_price').val();
		var price = /^\d+(\.\d{1,2})?$/;
		var pro_type = wkmp('#product_type');

		if (!product_type) {
			pro_type = wkmp('#product-form').find('input[name="product_type"]').val()
		}

		if (!wkmp.isNumeric(regu_price) && pro_type != 'variable' && pro_type != 'grouped') {
			wkmp('#regl_pr_error').html(wkmpObj.mkt_tr.mkt6);
			return false;
		} else {
			wkmp('#regl_pr_error').html('');
		}
	});

	//product sale price validation
	wkmp('#sale_price').blur(function () {

		var sale_price = wkmp('#sale_price').val();
		var price = /^\d+(\.\d{1,2})?$/;
		var regular = parseFloat(wkmp('#regu_price').val());
		var sale = parseFloat(wkmp('#sale_price').val());
		var pro_type = wkmp('#product_type');

		if (!product_type) {
			pro_type = wkmp('#product-form').find('input[name="product_type"]').val()
		}

		if ('' !== wkmp('#sale_price').val() && 'variable' !== pro_type && 'grouped' !== pro_type) {
			if (!wkmp.isNumeric(sale_price)) {
				wkmp('#sale_pr_error').html(wkmpObj.mkt_tr.mkt6);
				return false;
			} else if (sale >= regular) {
				wkmp('#sale_pr_error').html(wkmpObj.mkt_tr.mkt5);
				return false;
			} else {
				wkmp('#sale_pr_error').html('');
			}
		}
	});

	wkmp(document).on('blur', '.wkmp_variable_sale_price', function () {
		var sale_price = wkmp(this).val();
		var price = /^\d+(\.\d{1,2})?$/;
		var regular = parseFloat(wkmp(this).parent().siblings().children('.wkmp_variable_regular_price').val());
		var sale = parseFloat(wkmp(this).val());
		if ('' !== wkmp(this).val()) {
			if (!wkmp.isNumeric(sale_price)) {
				wkmp(this).siblings('.sale_pr_error').html(wkmpObj.mkt_tr.mkt6);
				return false;
			} else if (sale >= regular) {
				wkmp(this).siblings('.sale_pr_error').html(wkmpObj.mkt_tr.mkt5);
				return false;
			} else {
				wkmp('#sale_pr_error').html('');
			}
		}
	});
	// product validation end

	wkmp('.woocommerce-MyAccount-navigation-link--seperate-dashboard a').on('click', function (eve) {
		eve.preventDefault();
		wkmp.ajax({
			type: 'POST',
			url: wkmpObj.ajax.ajaxUrl,
			data: {
				"action": "wkmp_change_frontend_seller_dashboard",
				"change_to": 'backend_dashboard',
				"wkmp_nonce": wkmpObj.ajax.ajaxNonce
			},
			success: function (data) {
				if (data) {
					window.location.href = data.redirect;
				}
			}
		})
	});

	// Shipping related code start here

	wkmp(".wc-shipping-class-add").on("click", function (evt) {
		let rand_no = '';
		let html = '';
		wkmp(".wc-shipping-class-save").removeAttr("disabled");
		rand_no = Math.floor((Math.random() * 10000000) + 1);

		html += '<tr data-id="new-3-' + rand_no + '" class="editing">';
		html += '<td class="wc-shipping-class-name">';
		html += '<div class="view" style="display:none">';
		html += '<div class="row-actions">';
		html += '<a class="wc-shipping-class-edit" href="#">Edit</a> |';
		html += '<a href="#" class="wc-shipping-class-delete">' + wkmpObj.mkt_tr.ship1 + '</a>';
		html += '</div>';
		html += '</div>';
		html += '<div class="edit" style="display:block;">';
		html += '<input type="text" name="name[new-3-' + rand_no + ']" data-attribute="name" value="" placeholder="' + wkmpObj.mkt_tr.ship2 + '">';
		html += '<div class="row-actions">';
		html += '<a class="wc-shipping-class-cancel-edit" href="#">' + wkmpObj.mkt_tr.ship3 + '</a>';
		html += '</div>';
		html += '</div>';
		html += '</td>';
		html += '<td class="wc-shipping-class-slug">';
		html += '<div class="edit" style="display: block;">';
		html += '<input type="text" name="slug[new-3-' + rand_no + ']" data-attribute="slug" value="" placeholder="' + wkmpObj.mkt_tr.ship4 + '">';
		html += '</div>';
		html += '</td>';
		html += '<td class="wc-shipping-class-description">';
		html += '<div class="view" style="display: none;"></div>';
		html += '<div class="edit" style="display: block;">';
		html += '<input type="text" name="description[new-3-' + rand_no + ']" data-attribute="description" value="" placeholder="' + wkmpObj.mkt_tr.ship5 + '">';
		html += '</div>';
		html += '</td>';
		html += '<td class="wc-shipping-class-count"><a href=""></a></td>';
		html += '</tr>';
		wkmp("table.wc-shipping-classes tbody.wc-shipping-class-rows").append(html);
		evt.preventDefault();
	});

	wkmp(".wc-shipping-classes").on("click", ".wc-shipping-class-name .wc-shipping-class-edit", function (evt) {

		wkmp(".wc-shipping-class-save").removeAttr("disabled");
		wkmp(this).closest("tr").find(".view").hide();
		wkmp(this).closest("tr").find(".edit").show();

		evt.preventDefault();
	});

	wkmp(".wc-shipping-classes").on("click", ".wc-shipping-class-cancel-edit", function (evt) {
		wkmp(this).closest("tr").remove();
		evt.preventDefault();
	});

    wkmp("#ship_data").submit(function (evt) {
        wkmp('.wkmp-spin-loader').removeClass('wkmp_hide');
		wkmp.ajax({
			type: 'POST',
			url: wkmpObj.ajax.ajaxUrl,
			data: {
				"action": "wkmp_add_shipping_class",
				"data": wkmp("#ship_data").serialize(),
				"wkmp_nonce": wkmpObj.ajax.ajaxNonce
			},
            success: function (resp) {
                wkmp('.wkmp-spin-loader').addClass('wkmp_hide');
				window.location.href = resp.redirect;
			}
		});

		evt.preventDefault();
	});

	wkmp(".btn-save-cost").on("click", function (evt) {
		let shipping_cost = wkmp(this).closest(".shipping-method-add-cost").find("input,select").serialize();
        let instance_id = wkmp(this).prev().val();
        wkmp('.wkmp-spin-loader').show();
		wkmp.ajax({
			type: 'POST',
			url: wkmpObj.ajax.ajaxUrl,
			data: {
				"action": "wkmp_save_shipping_cost",
				"ship_cost": shipping_cost,
				"instance_id": instance_id,
				"wkmp_nonce": wkmpObj.ajax.ajaxNonce
			},
            success: function (data) {
                wkmp('.wkmp-spin-loader').hide();
				window.location.reload();
			}
		});
		evt.preventDefault();
	});

	// Delete shipping class.
	wkmp(".wk_del_ship_class").on("click", function (evt) {
        let term_id = wkmp(this).data('term');
        wkmp('.wkmp-spin-loader').removeClass('wkmp_hide');
		wkmp.ajax({
			type: 'POST',
			url: wkmpObj.ajax.ajaxUrl,
			data: {
				"action": "wkmp_delete_shipping_class",
				"get-term": term_id,
				"wkmp_nonce": wkmpObj.ajax.ajaxNonce
			},
            success: function (resp) {
                wkmp('.wkmp-spin-loader').removeClass('wkmp_hide');
                window.location.href = resp.redirect;
			}
		});
		evt.preventDefault();
	});

	wkmp(".wc-shipping-zones").on("click", ".wc-shipping-zone-cancel-edit", function (evt) {
		var dynElm = wkmp(this).closest("tr.editing");
		dynElm.remove();
		evt.preventDefault();
	});

	wkmp(".wc-shipping-zones").on("click", ".wc-shipping-zone-postcodes-toggle", function (evt) {
		wkmp(this).hide();
		wkmp(this).next(".wc-shipping-zone-postcodes").css('display', 'block');
		evt.preventDefault();
	});

	// Show list of countries and states on focus input box
	wkmp(document).on("focusin", "#unused_elm", function () {
		wkmp(this).siblings(".live-search-list").slideDown();
	});

	// On click to country or state show it on input box and save it on input type hidden
	wkmp(document).on("click", ".live-search-list li", function () {
		wkmp(this).parent(".live-search-list").slideUp();
		var currentVal = wkmp(this).text().trim();
		var searched_term = wkmp(this).data("search-term");
		tag = wkmp('<div class="mp_ship_tags" data-value=' + searched_term + '>' + currentVal + '<a class="mp_del_tag">x</a></div>');
		if ('' === wkmp(this).parent().prev("#mp_set_zone_location").val()) {
			wkmp(this).parent().prev("#mp_set_zone_location").val(wkmp(this).parent().prev("#mp_set_zone_location").val() + searched_term);
		} else {
			wkmp(this).parent().prev("#mp_set_zone_location").val(wkmp(this).parent().prev("#mp_set_zone_location").val() + ',' + searched_term);
		}

		tag.insertBefore(wkmp(this).parent().siblings("#unused_elm"), wkmp(this).parent().siblings("#unused_elm"));
		wkmp(this).parent().siblings("#unused_elm").val('');
	});

	wkmp(document).on('click', '.mp_del_tag', function () {
		var searched_term = wkmp(this).parent().data("value");
		if (searched_term) {
			var nowReq = wkmp(this).parent().siblings("#mp_set_zone_location").val();
			var new_term_1 = searched_term + ',';
			var new_term_2 = ',' + searched_term;
			if (nowReq.indexOf(new_term_1) !== -1) {
				var splitReq = nowReq.replace(searched_term + ',', "");
			} else if (nowReq.indexOf(new_term_2) !== -1) {
				var splitReq = nowReq.replace(',' + searched_term, "");
			} else {
				var splitReq = nowReq.replace(searched_term, "");
			}
			wkmp(this).parent().siblings("#mp_set_zone_location").val(splitReq);
			wkmp(this).parent().remove();
		}
	});

	// Limit search country or state result on every charater input
	wkmp(document).on('keyup', ".live-search-box", function () {
		var searchTerm = wkmp(this).val();
		var str = searchTerm.toLowerCase().replace(/\b[a-z]/g, function (letter) {
			return letter.toUpperCase();
		});
		wkmp(this).siblings('.live-search-list').find("li").each(function () {
			if (wkmp(this).is(":contains(" + str + ")") || str.length < 1) {
				wkmp(this).show();
			} else {
				wkmp(this).hide();
			}
		});
	});

	// Add Shipping Method
	wkmp(".add-ship-method").on("click", function () {
		let selectedZoneId = '';
		let selected_Shipmethod = '';
		selectedZoneId = wkmp("#add_method_id").data('get-zone');
		selected_Shipmethod = wkmp("#add_method_id").val();

        if (selected_Shipmethod && selectedZoneId) {
            wkmp('.shipping-method-modal .wkmp-spin-loader').show();
            wkmp(this).attr('disabled', 'disabled');
			wkmp.ajax({
				type: 'POST',
				url: wkmpObj.ajax.ajaxUrl,
				data: {
					"action": "wkmp_add_shipping_method",
					"zone-id": selectedZoneId,
					"ship-method": selected_Shipmethod,
					"wkmp_nonce": wkmpObj.ajax.ajaxNonce
				},
                success: function (data) {
                    wkmp('.shipping-method-modal .wkmp-spin-loader').hide();
					if (data) {
						location.reload();
					}
				}
			});
		}
	});

	// Delete shipping method_disable
	wkmp(".del-ship-method").on("click", function (ext) {
		let meth_id = '';
		let zone_id = '';
		let instance_id = '';
		meth_id = wkmp(this).data('methid');
		meth_id = meth_id.split('-');
		zone_id = meth_id[0];
		instance_id = meth_id[1];
		if (zone_id && instance_id) {
			wkmp.ajax({
				type: 'POST',
				url: wkmpObj.ajax.ajaxUrl,
				data: {
					"action": "wkmp_delete_shipping_method",
					"zone-id": zone_id,
					"instance-id": instance_id,
					"wkmp_nonce": wkmpObj.ajax.ajaxNonce
				},
				success: function (data) {
					if (data) {
						ext.target.closest('li').remove();
					}
					//location.reload();
				}
			});
		}
	});

	// Delete shipping Zones
	wkmp(".wc-shipping-zone-delete").on("click", function (evt) {
		let ret_val = '';
		let getElm = '';
		let del_zone = '';
		ret_val = confirm(wkmpObj.mkt_tr.ship6);
		if (ret_val) {
			getElm = wkmp(this);
			if (typeof getElm.data("zone-id") !== 'undefined') {
				del_zone = getElm.data('zone-id');
                if (del_zone) {
                    wkmp('.wkmp-spin-loader').removeClass('wkmp_hide');
					wkmp.ajax({
						type: 'POST',
						url: wkmpObj.ajax.ajaxUrl,
						data: {
							"action": "wkmp_del_zone",
							"zone-id": del_zone,
							"wkmp_nonce": wkmpObj.ajax.ajaxNonce
						},
                        success: function (resp) {
                            wkmp('.wkmp-spin-loader').addClass('wkmp_hide');
                            window.location.href = resp.redirect;
						}
					});
				}
			}
			evt.preventDefault();
		}
	});
	// Shipping related code end here

	wkmp("#wkmp-submit-ask-form").on('click', function (event) {
		event.preventDefault();

		wkmp('#wkmp-subject-error').text('');
		wkmp('#wkmp-message-error').text('');

		let subject = '';
		let message = '';
		let status = true;

		subject = wkmp('#wkmp-subject').val();
		message = wkmp('#wkmp-message').val();

		if (subject.length < 3 || subject.length > 50) {
			status = false;
			wkmp('#wkmp-subject-error').text(wkmpObj.mkt_tr.mkt40);
		}

		if (message.length < 5 || message.length > 255) {
			status = false;
			wkmp('#wkmp-message-error').text(wkmpObj.mkt_tr.mkt41);
		}

		if (status) {
			if (wkmp('#wkmp-seller-sendmail-form').length > 0) {
				wkmp('#wkmp-seller-sendmail-form').submit();
			}

			if (wkmp('#wkmp-seller-query-form').length > 0) {
				wkmp('#wkmp-seller-query-form').submit();
			}
		}

	});

	wkmp(document).on('click', 'a.upload_var_image_button', function (event) {
		var file_frame;
		var image_id = wkmp(this).attr('id');
		var image_val_id = 'upload_' + image_id;
		var image_url_set_id = 'wkmp_variation_product_' + image_id;
		event.preventDefault(); // If the media frame already exists, reopen it.

		if (file_frame) {
			file_frame.open();
			return;
		} // Create the media frame.

		let selection = '';


		file_frame = wp.media.frames.file_frame = wp.media({
			title: wkmp(this).data('uploader_title'),
			button: {
				text: wkmp(this).data('uploader_button_text')
			},
			multiple: false // Set to true to allow multiple files to be selected

		}); // When frame is open, select existing image attachments from custom field

		file_frame.on('open', function () {
			selection = file_frame.state().get('selection');
		});
		var query = wp.media.query();

		query.filterWithIds = function (ids) {
			return _(this.models.filter(function (c) {
				return _.contains(ids, c.id);
			}));
		}; // When images are selected, place IDs in hidden custom field and show thumbnails.


		file_frame.on('select', function () {
			selection = file_frame.state().get('selection'); // Place IDs in custom field

			var attachment_ids = selection.map(function (attachment) {
				attachment = attachment.toJSON();
				wkmp('#' + image_val_id).val(attachment.id);
				wkmp('#' + image_url_set_id).attr("src", attachment.sizes.thumbnail.url);
				return attachment.id;
			});
		}); // Finally, open the modal

		file_frame.open();
	});

	//Woodmart theme compatibility to remove anti-spam field from woocommerce my-account page registration field.
	wkmp(document).ready(function (event) {
		if (wkmp('.wd-login-title').length > 0 && wkmp('.nav.wkmp-role-selector').length > 0) {
			wkmp('input[name=email_2][id=trap]').parent().empty();
		}
	});

	/* Show sale schedule */
	wkmp(document).on("click", '.mp_sale_schedule', function () {
		wkmp(this).css('display', 'none');
		wkmp(this).siblings('.mp_cancel_sale_schedule').css('display', 'inline-block');
		wkmp(this).parents('tr').siblings('.mp_sale_price_dates_fields').css('display', 'table-row');
	});
	wkmp(document).on("click", '.mp_cancel_sale_schedule', function () {
		wkmp(this).css('display', 'none');
		wkmp(this).siblings('.mp_sale_schedule').css('display', 'inline-block');
		wkmp(this).parents('tr').siblings('.mp_sale_price_dates_fields').css('display', 'none');
	});

	//Minimum  order setting popup from seller front end.
	wkmp('body').on('click', '#wkmp_product_misc_settings', function () {
		wkmp('#wkmp_minimum_order_model').css('display', 'block');
	});

	/** Submitting minimum order form. **/
	wkmp("#wkmp-submit-min-order-amount-update").on('click', function (event) {
		event.preventDefault();

		let status = true;
		let amount_input = wkmp('input[name=_wkmp_minimum_order_amount]');
		let amount = wkmp(amount_input).val().trim();
		let empty_amount_allow = parseInt(wkmp(amount_input).attr('data-empty_allow'));

		if (empty_amount_allow < 1 && (isNaN(amount) || (!isNaN(amount) && !(amount > 0)))) {
			status = false;
			wkmp('#wkmp-amount-error').text(wkmpObj.mkt_tr.mkt42);
		}

		let qty_input = wkmp('input[name=_wkmp_max_product_qty_limit]');
		let qty = wkmp(qty_input).val();
		let empty_qty_allow = parseInt(wkmp(qty_input).attr('data-empty_allow'));

		if (empty_qty_allow < 1 && (isNaN(qty) || (!isNaN(qty) && !(qty > 0) || (!isNaN(qty) && !(isNormalInteger(qty)))))) {
			status = false;
			wkmp('#wkmp-max-qty-limit-error').text(wkmpObj.mkt_tr.mkt47);
		}

		if (status) {
			wkmp('#wkmp-amount-error').text('');
			wkmp('#wkmp-max-qty-limit-error').text('');
			wkmp('form#wkmp-seller-min-order-amount-form').submit();
		}
	});

	function isNormalInteger(str) {
		str = str.trim();
		if (!str) {
			return false;
		}
		str = str.replace(/^0+/, "") || "0";
		var n = Math.floor(Number(str));
		return n !== Infinity && String(n) === str && n >= 0;
	}

	// Clearing min order amount from seller miscellaneous settings click.
	wkmp('#wkmp_clear_min_order_amount').on('click', function () {
		let amount_input = wkmp('input[name=_wkmp_minimum_order_amount]');
		let data_empty_allow = parseInt(wkmp(amount_input).attr('data-empty_allow'));
		if (data_empty_allow > 0) {
			wkmp(amount_input).attr('data-empty_allow', 0).attr('readOnly', false).attr('placeholder', wkmpObj.mkt_tr.mkt43);
			wkmp(this).text(wkmpObj.mkt_tr.mkt44);
		} else {
			wkmp(amount_input).attr('data-empty_allow', 1).val('').attr('readOnly', true).attr('placeholder', wkmpObj.mkt_tr.mkt45);
			wkmp(this).text(wkmpObj.mkt_tr.mkt46);
			wkmp('#wkmp-amount-error').text('');
		}
	});

	// Clearing maximum quantity from seller miscellaneous settings click.
	wkmp('#wkmp_clear_max_qty_limit').on('click', function () {
		let qty_input = wkmp('input[name=_wkmp_max_product_qty_limit]');
		let empty_qty_allow = parseInt(wkmp(qty_input).attr('data-empty_allow'));
		if (empty_qty_allow > 0) {
			wkmp(qty_input).attr('data-empty_allow', 0).attr('readOnly', false).attr('placeholder', wkmpObj.mkt_tr.mkt48);
			wkmp(this).text(wkmpObj.mkt_tr.mkt44);
		} else {
			wkmp(qty_input).attr('data-empty_allow', 1).val('').attr('readOnly', true).attr('placeholder', wkmpObj.mkt_tr.mkt45);
			wkmp(this).text(wkmpObj.mkt_tr.mkt46);
			wkmp('#wkmp-max-qty-limit-error').text('');
		}
	});

	/** Hiding max purchasable quantity if sold individually is enabled. **/
	wkmp('#wk_sold_individual').on('click', function () {
		if (wkmp(this).is(':checked')) {
			wkmp('.wkmp-max-product-qty-limit').hide();
		} else {
			wkmp('.wkmp-max-product-qty-limit').show();
		}
	});

});
